

$(function(){

  // デバイス判定
  $(window).on('load resize', function(){
    var x = $(window).width();
    var y = 768;
    if (x <= y) {
      $('html').addClass('sp').removeClass('pc');
    }else{
      $('html').addClass('pc').removeClass('sp');
    }
  });

  // ヘッダー省略表示・ページトップボタン 表示・非表示
  $(window).on("scroll", function(){
    var tp = $(window).scrollTop();
    if(tp > $("#header").height()){
      $("#topBtn").addClass("show");
    }else{
      $("#topBtn").removeClass("show");
    }
    $('#header .inner-pc .logo').toggleClass('hide', $(this).scrollTop() > 89);
    $('#header .inner-pc #sns').toggleClass('hide', $(this).scrollTop() > 89);
    $('#header .inner-sp').toggleClass('hide', $(this).scrollTop() > 89);
  }).trigger('scroll')

  // PC サブナビ 表示・非表示
  $("#header #gnav .nav-item").hover(function() {
    $('#gnav').find('.snav').removeClass('show');
    $(this).children("ul").toggleClass("show");
  }, function(){
    $('#gnav').find('.snav').removeClass('show');
  });

  // SP サブナビ 表示・非表示
  $(".acc").each(function(){

    if($(this).hasClass("open")){
    }else{
      $(this).find(".acc__body").hide();
    }
    
    //$(this).find(".acc__body").hide();
    $(this).find(".acc__header").on("click", (function(target){
      
      
      return function(){
        if(target.hasClass("open")){
          target.removeClass("open")
          target.find(".acc__body").slideUp();
          if(target.find(".acc__header img").length > 0){
            var src = target.find(".acc__header img").attr("src");
            target.find(".acc__header img").attr("src", src.replace("_c.png", ".png"));
          }
        }else{
          target.addClass("open")
          target.find(".acc__body").slideDown();
          if(target.find(".acc__header img").length > 0){
            var src = target.find(".acc__header img").attr("src");
            target.find(".acc__header img").attr("src", src.replace(".png", "_c.png"));
          }
        }
      }
    })($(this)))
  });


  $("#topBtn .sp-none").hover(
    function(){
      $(this).attr("src", $(this).attr("src").replace("_off", "_on"));
    },
    function(){
      $(this).attr("src", $(this).attr("src").replace("_on", "_off"));
  });

  /*
  // topコンテンツ内ナビ _ロールオーバー
  $(".p-top_imgmap a").hover(
  function(){
    if($('html').hasClass('pc')) {
      $(this).find('img').attr("src", $(this).find('img').attr("src").replace("_off", "_on"));
    }
  },
  function(){
    if($('html').hasClass('pc')) {
      $(this).find('img').attr("src", $(this).find('img').attr("src").replace("_on", "_off"));
    }
  });
  */
  // topコンテンツ内ナビ _ロールオーバー
  /*
  $(".btn a").hover(
  function(){
    if($('html').hasClass('pc')) {
      $(this).find('img').attr("src", $(this).find('img').attr("src").replace("_off", "_on"));
    }
  },function(){
    if($('html').hasClass('pc')) {
      $(this).find('img').attr("src", $(this).find('img').attr("src").replace("_on", "_off"));
    }
  });
  */

  // ページトップ
  $("#topBtn").on("click", function(){
    $("html,body").animate({
      scrollTop: 0
    }, 400)
  });

  //spメニュー開閉
  $("#menuOpen").on("click", function(){
    $("#sp-menu").show();
  })
  $("#menuClose").on("click", function(){
    $("#sp-menu").hide();
  })

  $("#sp-menu").click(function() {
    $(this).hide();
  });
  $("#menuOpen").click(function(event) {　event.stopPropagation();　});
  $('.menu-inner').click(function(event) {　event.stopPropagation();　});

  $('#sp-menu .acc__body a').click(function() {
    $("#sp-menu").hide();
  });

  //news一覧展開
  var mode = 0;
  $("#newsOpen").on("click", function(){
    $("body").css("overflow", "hidden");
    mode = 0;
    $("#overlay").show();
    $("#overlayContent").show();
    $("#overlayContent .overlayContent__inner").append($("#newsContent"));
    return false;
  })
  $("#overlayClose").on("click", function(){
    $("body").css("overflow", "auto");
    if(mode == 0){
      $("#hHolder").append($("#newsContent"));
    }else if(mode == 1){
      $("#overlayContent .overlayContent__inner").empty();
    }
    $("#overlay").hide();
    $("#overlayContent").hide();
    return false;
  })

  //ページ内スクロール
  /*$("#gnav, .snav, #sp-menu li").find("a").each(function(){
    $(this).on("click", function(){
      var target = $(this);
      var href = target.attr("href");
      var page = href.split("/")[4];
      var hash = href.split("/")[5];
      if($(".page-" + page).length > 0){
        targetY = $(hash).offset().top;
        $("html,body").animate({
          scrollTop: targetY
        }, 500, 'swing');
        return false;
      }
    })
  })*/

});
